import { db } from './firebase';

const settings = {timestampsInSnapshots: true};
db.settings(settings);


export const getAlerts = (orgID) => {
  var baseRef = db.collection('Alerts');
  var queryRef = baseRef.where('orgId','==',orgID);
  return queryRef.orderBy("dateTimeSent","desc").get();
}

export const getCourseByGradeLevel = (gradeLevel) => {
  return new Promise(function(resolve, reject) {
    var baseRef = db.collection('Courses');
    var queryRef = baseRef.where('GradeLevel','==',gradeLevel);
    queryRef.get().then(snapshot => {

      snapshot.forEach((doc) => {
        var obj = doc.data();
        obj.id = doc.id;
        resolve(obj);
      });
    }) ;
  });
}

export const getJournalByLessonAndUser = (userID, lessonID) => {
  var baseRef = db.collection('Journals');
  var queryRef = baseRef.where('UserID','==',userID).where('LessonID','==',lessonID);
  return queryRef.get();
}

export const getLesson = (id) => 
  db.collection('Lessons').doc(id).get();

export const getLessonsByCourse = (courseID) => {
  var baseRef = db.collection('Lessons');
  var queryRef = baseRef.where('Course','==',courseID);
  return queryRef.orderBy("Week","asc").get();
}
  
export const getLocations = (orgID) => {
  var baseRef = db.collection('Locations');
  var queryRef = baseRef.where('orgId','==',orgID);
  return queryRef.orderBy("Name","desc").get();
}

export const getSupportMaterial = (id) => {
  return new Promise(function(resolve, reject) {
    try
    {
      var baseRef = db.collection('Materials');
      var queryRef = baseRef.where('IsVisible','==',true);
      return queryRef.orderBy("Type","asc").orderBy("Name","asc").get().then(snapshot => {
        var objs = [];
        snapshot.forEach((doc) => {
          var d = doc.data();
          d.id = doc.id;
          objs.push(d);
        });
        resolve(objs);
      });
    }
    catch(exception) {
      console.log('db.getSupportMaterial() EXCEPTION');
      console.log(exception);
    }
  });
}

export const getOrdersBySchool = (id) => {
  return new Promise(function(resolve, reject) {
    try
    {
      var baseRef = db.collection('Orders');
      var queryRef = baseRef.where('schoolID','==',id);
      return queryRef.orderBy("modified","desc").get().then(snapshot => {
        var orders = [];
        snapshot.forEach((doc) => {
          var d = doc.data();
          d.id = doc.id;
          orders.push(d);
        });
        resolve(orders);
      });
    }
    catch(exception) {
      console.log('db.getOrdersBySchool() EXCEPTION');
      console.log(exception);
    }
  });
}

export const getOrganization = (id) =>
  db.collection('Organizations').doc(id).get();

export const getProduct = (id) =>
  db.collection('Products').doc(id).get();

export const getProducts = (orgID) => {
  var baseRef = db.collection('Products');
  var queryRef = baseRef.where('orgId','==',orgID);
  return queryRef.orderBy("Name","desc").get();
}

export const getPurchases = (orgID) => {
  var baseRef = db.collection('Purchases');
  var queryRef = baseRef.where('orgId','==',orgID);
  return queryRef.orderBy("created","desc").get();
}

export const getSchool = (id) => {
  return new Promise(function(resolve, reject) {
    db.collection('Schools').doc(id).get().then((doc) => {
      var school = doc.data();
      school.id = doc.id;
      resolve(school);
    });;
  });
}

export const getSchoolByLoginPath = (loginPath) => {
  var baseRef = db.collection('Schools');
  var queryRef = baseRef.where('LoginPath','==',loginPath);
  return queryRef.orderBy("Name","desc").get();
}

export const getSettings = (id) => {
  return new Promise(function(resolve, reject) {
    db.collection('Settings').doc(id).get().then(doc => {
      var obj = doc.data();
      obj.id = doc.id;
      resolve(obj);
    });
  });
}

export const getStripeAccount = (id) =>
  db.collection('StripeAccounts').doc(id).get();

export const getUser = (id) => 
  db.collection('Users').doc(id).get();

export const getVideo = (id) => 
  db.collection('Videos').doc(id).get();
  
export const getVideosByQuarterAndWeek = (quarter, week) => {

  return new Promise(function(resolve, reject) {
    var baseRef = db.collection('Videos');
    var queryRef = baseRef.where('Quarter','==',quarter).where('Week','==',week);
    queryRef.get().then(snapshot => {
      
      var objs = [];
      snapshot.forEach((doc) => {
        var obj = doc.data();
        obj.id = doc.id;
        objs.push(obj);
      });

      resolve(objs);
    });
  });
}

export const getVideosByType = (type) => {

  return new Promise(function(resolve, reject) {
    var baseRef = db.collection('Videos');
    var queryRef = baseRef.where('Type','==',type);
    queryRef.get().then(snapshot => {
      
      var objs = [];
      snapshot.forEach((doc) => {
        var obj = doc.data();
        obj.id = doc.id;
        objs.push(obj);
      });

      resolve(objs);
    });
  });
}

export const logActivity = (userID, orgID, schoolID, classID, activityType, objectID) => {

  if(typeof userID === 'undefined')
    userID = null;

  if(typeof schoolID === 'undefined')
    schoolID = null;

  if(typeof classID === 'undefined')
    classID = null;

  if(typeof objectID === 'undefined')
    objectID = null;

    if(typeof orgID === 'undefined')
    orgID = null;

  var activity = {
    UserID: userID,
    SchoolID: schoolID,
    ClassID: classID,
    ActivityType: activityType,
    ObjectID: objectID,
    orgID: orgID,
    modified: Math.round((new Date()).getTime() / 1000)
  }

  return db.collection('Activity').add(activity);
}

export const updateJournal = (id, value) => {
  if(typeof id === 'undefined')
    return db.collection('Journals').add(value);
  else 
    return db.collection('Journals').doc(id).set(value);
}

export const updateOrder = (id, value) => {
  if(typeof id === 'undefined')
    return db.collection('Orders').add(value);
  else 
    return db.collection('Orders').doc(id).set(value);
}
  
export const updateOrganization = (id, value) => {
  if(id === 0) 
    return db.collection('Organizations').add(value);
  else 
    return db.collection('Organizations').doc(id).set(value);
}

export const updateProduct = (id, value) => {
  if(typeof id === 'undefined')
    return db.collection('Products').add(value);
  else 
    return db.collection('Products').doc(id).set(value);
}
  
export const updateUser = (id, value) => {
  if(typeof id === 'undefined')
    return db.collection('Users').add(value);
  else 
    return db.collection('Users').doc(id).set(value);
}


// WEBPACK FOOTER //
// ./src/assets/firebase/db.js